module.exports = __webpack_public_path__ + "img/pic-one.fed7c941.png";